type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogData {
  timestamp: string;
  level: LogLevel;
  message: string;
  data?: unknown;
}

class Logger {
  private isDevelopment = import.meta.env.DEV;

  log(level: LogLevel, message: string, data?: unknown) {
    // Skip debug logs in production
    if (!this.isDevelopment && level === 'debug') return;

    const timestamp = new Date().toISOString();
    const logData: LogData = { 
      timestamp, 
      level, 
      message, 
      ...(data && { data }) 
    };

    // In production, only log errors (can be extended to monitoring service)
    if (!this.isDevelopment && level === 'error') {
      this.sendToMonitoring(logData);
    }

    // Console output for development only
    if (this.isDevelopment) {
      const consoleMethod = level === 'debug' ? 'log' : level;
      console[consoleMethod](`[${level.toUpperCase()}] ${message}`, data || '');
    }
  }

  debug(message: string, data?: unknown) { 
    this.log('debug', message, data); 
  }
  
  info(message: string, data?: unknown) { 
    this.log('info', message, data); 
  }
  
  warn(message: string, data?: unknown) { 
    this.log('warn', message, data); 
  }
  
  error(message: string, data?: unknown) { 
    this.log('error', message, data); 
  }

  private sendToMonitoring(data: LogData) {
    // TODO: Integrate with monitoring service (e.g., Sentry)
    // For now, just console.error in production
    console.error('[PRODUCTION ERROR]', data);
  }
}

export const logger = new Logger();
